import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, message, Modal } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';

const CPedidosCliente = () => {
    const [pedidos, setPedidos] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detallesSeleccionados, setDetallesSeleccionados] = useState([]);
    const { user } = useContext(LoginContext);

    useEffect(() => {
        fetchPedidos();
    }, []);

    const fetchPedidos = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${user.token}`,
            };
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/pedido/cliente/${user.user.id}`, { headers });
            setPedidos(response.data);
        } catch (error) {
            message.error('Error al obtener los pedidos');
        }
    };

    const handleVerDetalles = (items) => {
        setDetallesSeleccionados(items);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
    };

    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (fecha) => new Date(fecha).toLocaleString(),
        },
        {
            title: 'Estado',
            dataIndex: 'estado',
            key: 'estado',
        },
        {
            title: 'Acciones',
            key: 'acciones',
            render: (text, record) => (
                <Button
                    type="primary"
                    onClick={() => handleVerDetalles(record.items)}
                >
                    Ver Detalles
                </Button>
            ),
        },
    ];

    return (
        <div>
            <h2>Pedidos del Usuario</h2>
            <Table
                columns={columns}
                dataSource={pedidos}
                rowKey="_id"
                pagination={{ pageSize: 10 }}
            />

            {/* Modal para ver los detalles de los pedidos */}
            <Modal
                title="Detalles del Pedido"
                visible={isModalVisible}
                onCancel={handleModalClose}
                footer={[
                    <Button key="close" onClick={handleModalClose}>
                        Cerrar
                    </Button>,
                ]}
                width={800}
            >
                <Table
                    dataSource={detallesSeleccionados}
                    rowKey="_id"
                    pagination={false}
                    columns={[
                        {
                            title: 'Nombre del Artículo',
                            dataIndex: ['articulo', 'nombre'],
                            key: 'nombre'
                        },
                        {
                            title: 'Marca',
                            dataIndex: ['articulo', 'idmarca', 'nombre'],
                            key: 'marca'
                        },
                        {
                            title: 'Categoría',
                            dataIndex: ['articulo', 'idcategoria', 'nombre'],
                            key: 'categoria'
                        },
                        {
                            title: 'Cantidad',
                            dataIndex: 'cantidad',
                            key: 'cantidad',
                        },
                    ]}
                    scroll={{ x: 800 }}
                />
            </Modal>
        </div>
    );
};

export default CPedidosCliente;
